import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { MarkupProvider } from './contexts/MarkupContext';
import { UserProvider } from './contexts/UserContext';
import { PermissionProvider } from './contexts/PermissionContext';
import AuthGuard from './guards/AuthGuard';
import RoleGuard from './guards/RoleGuard';
import Layout from './components/Layout';
import Login from './pages/Login';
import GoogleCallback from './pages/GoogleCallback';
import Dashboard from './pages/Dashboard';
import Unauthorized from './pages/Unauthorized';
import Emissions from './pages/Emissions';
import EmissionDetail from './pages/EmissionDetail';
import BusEmissions from './pages/BusEmissions';
import BusEmissionDetail from './pages/BusEmissionDetail';
import Markups from './pages/Markups';
import Users from './pages/Users';
import Airports from './pages/Airports';
import Settings from './pages/Settings';
import Leads from './pages/Leads';
import Coupons from './pages/Coupons';
import QuotePage from './pages/QuotePage';
import BusManualCheckout from './pages/BusManualCheckout';
import FlightManualCheckout from './pages/FlightManualCheckout';
import Terms from './pages/Terms';
import InstallmentRates from './pages/InstallmentRates';
import BaggageRules from './pages/BaggageRules';
import MileageCards from './pages/MileageCards';

function App() {
  return (
    <div className="main">
      <AuthProvider>
        <PermissionProvider>
          <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/google/callback" element={<GoogleCallback />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            
            <Route path="/" element={
              <AuthGuard>
                <Layout />
              </AuthGuard>
            }>
              <Route path="/dashboard" element={<Dashboard />} />
              
              <Route path="/users" element={
                <RoleGuard allowedRoles={['admin']} requiredPermissions={['users.read']}>
                  <UserProvider>
                    <Users />
                  </UserProvider>
                </RoleGuard>
              } />
              
              <Route path="/emissions" element={
                <RoleGuard allowedRoles={['admin', 'emissor', 'reader']} requiredPermissions={['emissions.read']}>
                  <Emissions />
                </RoleGuard>
              } />
              
              <Route path="/emissions/:id" element={
                <RoleGuard allowedRoles={['admin', 'emissor', 'reader']} requiredPermissions={['emissions.read']}>
                  <EmissionDetail />
                </RoleGuard>
              } />
              
              <Route path="/bus-emissions" element={
                <RoleGuard allowedRoles={['admin', 'emissor', 'reader']} requiredPermissions={['emissions.read']}>
                  <BusEmissions />
                </RoleGuard>
              } />
              
              <Route path="/bus-emissions/:id" element={
                <RoleGuard allowedRoles={['admin', 'emissor', 'reader']} requiredPermissions={['emissions.read']}>
                  <BusEmissionDetail />
                </RoleGuard>
              } />
              
              <Route path="/markups" element={
                <RoleGuard allowedRoles={['admin', 'gestor']} requiredPermissions={['markups.read']}>
                  <MarkupProvider>
                    <Markups />
                  </MarkupProvider>
                </RoleGuard>
              } />
              
              <Route path="/airports" element={
                <RoleGuard allowedRoles={['admin']} requiredPermissions={['airports.read']}>
                  <Airports />
                </RoleGuard>
              } />
              
              <Route path="/leads" element={
                <RoleGuard allowedRoles={['admin', 'emissor', 'gestor', 'reader']} requiredPermissions={['leads.read']}>
                  <Leads />
                </RoleGuard>
              } />
              
              <Route path="/coupons" element={
                <RoleGuard allowedRoles={['admin']} requiredPermissions={['coupons.read']}>
                  <Coupons />
                </RoleGuard>
              } />

              <Route path="/quotes" element={
                <RoleGuard allowedRoles={['admin', 'emissor']} requiredPermissions={['emissions.read']}>
                  <QuotePage />
                </RoleGuard>
              } />

              <Route path="/bus-manual-checkout" element={
                <RoleGuard allowedRoles={['admin', 'emissor']} requiredPermissions={['emissions.read']}>
                  <BusManualCheckout />
                </RoleGuard>
              } />

              <Route path="/flight-manual-checkout" element={
                <RoleGuard allowedRoles={['admin', 'emissor']} requiredPermissions={['emissions.read']}>
                  <FlightManualCheckout />
                </RoleGuard>
              } />
              
              <Route path="/settings" element={
                <RoleGuard allowedRoles={['admin']} requiredPermissions={['settings.read']}>
                  <Settings />
                </RoleGuard>
              } />

              <Route path="/terms" element={
                <RoleGuard allowedRoles={['admin']}>
                  <Terms />
                </RoleGuard>
              } />

              <Route path="/installment-rates" element={
                <RoleGuard allowedRoles={['admin']}>
                  <InstallmentRates />
                </RoleGuard>
              } />

              <Route path="/baggage-rules" element={
                <RoleGuard allowedRoles={['admin', 'gestor']}>
                  <BaggageRules />
                </RoleGuard>
              } />

              <Route path="/mileage-cards" element={
                <RoleGuard allowedRoles={['admin']}>
                  <MileageCards />
                </RoleGuard>
              } />
              
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Route>
            
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
        </PermissionProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
